import React from "react";
import { createRoot } from "react-dom/client";
import App from "./pages/_app";
import * as serviceWorker from "./serviceWorker";
import "./components/custom-ui/emoji/emojiFlagPolyfill.css";
import { initEmojiFlagPolyfill } from "./components/custom-ui/emoji/initEmojiFlagPolyfill";

initEmojiFlagPolyfill();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
